module.exports = {"511113100":"永和镇","511113101":"金河镇","511113200":"和平彝族乡","511113201":"共安彝族乡","511113202":"吉星乡","511113203":"永胜乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/511113.json
// module id = 2332
// module chunks = 0